import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from './auth';
import SettingModule from './setting';
import BookingModule from './booking';
import HistoryModule from './history';
import ReviewModule from './review';
import ManageModule from './manage';
import FormModule from './form';
import NewsModule from './news';
import { UploadService, ExportExcelService} from '../services';
import {routeDefs} from '../routes';

Vue.use(Vuex);


export async function bindLoading(commit, action, ns = '', options = {delay: 200, ignoreGlobal: false}) {
    commit({
        type: 'saveLoading',
        loading: true,
        ns,
        ignoreGlobal: options.ignoreGlobal
    }, {root: true});

    await new Promise(resolve => {
        setTimeout(() => resolve(true), options.delay)
    });

    const result = await action();

    commit({
        type: 'saveLoading',
        loading: false,
        root: true,
        ns
    }, {root: true});
    return result;
}

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        setting: SettingModule,
        booking: BookingModule,
        history: HistoryModule,
        form: FormModule,
        review: ReviewModule,
        manage: ManageModule,
        news: NewsModule
    },
    state: {
        loading: {
            global: false,
            actions: {}
        },
    },
    getters: {
        menuDefs(state) {
            const filterFunc = r => r.show &&
                (r.claims.length <= 0 ||
                    r.claims.some(c => state.auth.claims.some(cc => cc === c))
                );
            const subMenusGrp = routeDefs
                .filter(r => r.parent)
                .filter(filterFunc)
                .reduce((grp, {title, path, exact, name, parent}) => {
                    (grp[parent]
                        = (grp[parent] || []))
                        .push({title, path, exact, name});
                    return grp;
                }, {});
            const topMenus = routeDefs
                .filter(r => !r.parent)
                .filter(filterFunc)
                .map(t => ({
                    ...t,
                    children: subMenusGrp.hasOwnProperty(t.name) ? subMenusGrp[t.name] : []
                }));
            return topMenus
                .map(({title, path, exact, name, children}) => ({title, path, exact, name, children}));
        }
    },
    mutations: {
        saveLoading(current, {loading, ns = '', ignoreGlobal = false}) {
            current.loading.global = ignoreGlobal ? false : loading;

            if (ns) {
                if (current.loading.actions.hasOwnProperty(ns)) {
                    current.loading.actions[ns] = loading;
                } else {
                    Vue.set(current.loading.actions, ns, loading);
                }
            }
        },
        resetLoading(current) {
            current.loading.global = false;
            Vue.set(current.loading, 'actions', {});
        }
    },
    actions: {
        async removeFileAction({dispatch, commit}, {key, encrypted}) {
            await UploadService.removeFile({key, encrypted});
        },
        async downloadFileAction(_, payload) {
            const url = window.URL.createObjectURL(new Blob([await UploadService.download({
                f: payload.key
            })]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', payload.fullName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async exportExcelAction(_, params) {
            const url = window.URL.createObjectURL(
                new Blob([await ExportExcelService.exportExcel(params)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', params.fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
});